export const MAX_CENTERED_IMAGE_WIDTH = 600;
export const MAX_NON_CENTERED_IMAGE_WIDTH = 582;
export const MAX_MOBILE_IMAGE_WIDTH = 480;
